import React, { useState, useRef } from 'react'
import { Button, Input, Spinner, Col, CustomInput, Row } from '@/components/ui-compat'
import { useTranslation } from 'react-i18next'

export default ({
  onExpand,
  onClose,
  onSubmit,
  expanded,
  loading,
  editMode = false,
  initialMessage = '',
  initialIsPublic = false,
}) => {
  const { t } = useTranslation()
  const [showTextInput, setShowTextInput] = useState(expanded)
  const [isPublic, setIsPublic] = useState(editMode ? initialIsPublic : false)
  const messageInputRef = useRef()

  // Set initial message when in edit mode
  React.useEffect(() => {
    if (editMode && messageInputRef.current && initialMessage) {
      messageInputRef.current.value = initialMessage
    }
  }, [editMode, initialMessage])

  const handleSend = async () => {
    setShowTextInput(false)
    onSubmit && onSubmit(messageInputRef.current.value, isPublic)
    if (!editMode) {
      messageInputRef.current.value = ''
    }
  }

  if (showTextInput && expanded)
    return (
      <Row>
        <Col style={{ marginLeft: editMode ? '0px' : '45px' }}>
          <input
            type="text"
            className="mt-2 form-control form-control-lg"
            placeholder={t('Tender_timeline_write_a_message')}
            onKeyDown={({ keyCode }) => keyCode === 13 && handleSend()}
            ref={messageInputRef}
            disabled={loading}
            defaultValue={editMode ? initialMessage : ''}
          />
          <ButtonsWrapper className={'float-right mt-2'}>
            <CustomInput
              id={editMode ? 'editPublic' : 'replyAll'}
              type="checkbox"
              className={'mr-3'}
              label={t('Tender_timeline_reply_to_all', 'Visible to all')}
              checked={isPublic}
              onChange={(e) => {
                setIsPublic(e.target.checked)
              }}
            />
            <Button
              color="outline-secondary"
              className={'mr-1'}
              onClick={() => {
                setShowTextInput(false)
                onClose && onClose()
              }}
            >
              {t('Tender_timeline_cancel_btn', 'Cancel')}
            </Button>
            <Button
              disabled={loading}
              color="outline-primary"
              onClick={() => {
                handleSend()
              }}
            >
              {editMode
                ? t('Tender_timeline_update_btn', 'Update')
                : t('Tender_timeline_send_btn', 'Send')}
            </Button>
          </ButtonsWrapper>
        </Col>
      </Row>
    )

  return (
    // <Row>
    //   <Col>
    <Button
      color="link"
      disabled={loading}
      className={'float-right btn-sm'}
      onClick={() => {
        setShowTextInput(true)
        onExpand && onExpand()
      }}
    >
      {editMode ? t('Tender_timeline_edit_btn', 'Edit') : t('Tender_timeline_reply_btn', 'Reply')}{' '}
      {loading && <SpinnerButton />}
    </Button>
    //   </Col>
    // </Row>
  )
}

const ButtonsWrapper = ({ children, ...props }) => (
  <div style={{ display: 'inline-flex', alignItems: 'center' }} {...props}>{children}</div>
)
const SpinnerButton = () => <Spinner size="sm" style={{ verticalAlign: 'middle' }} />
